import { useEffect } from 'react';
import { useStore } from '@nanostores/react';
import {
  Panel,
  PanelHeader,
  PanelTitle,
  PanelDescription,
  PanelSection,
  Box,
} from '@customerio/pluma-components/react';
import { DocumentTitle } from '@/components/page/document-title';
import { AddPeopleActions } from '@/features/add-people';
import { useAnalytics } from '@/services/analytics';
import { billing } from '@/services/billing';
import { useProductTaxonomy } from '@/services/product-taxonomy';

/**
 * The migrated `/profiles/create` page — Ember's `people.create` route. Unlike
 * the onboarding page at `/home/add-people`, this one hides the integrations
 * grid for Builder-plan accounts, matching Ember's `billing.isBuilder` branch.
 */
export default function PeopleCreatePage() {
  const taxonomy = useProductTaxonomy();
  const { track } = useAnalytics();
  const isBuilder = useStore(billing.isBuilder);

  useEffect(() => {
    void track('people', 'addPeopleModalViewed', {});
    // oxlint-disable-next-line react/exhaustive-deps
  }, []);

  const handleActionClick = (title: string) => {
    void track('people', 'addPeopleActionClicked', {
      'Action Name': title,
      'Page Name': 'people.create',
    });
  };

  return (
    <>
      <DocumentTitle title={`Add ${taxonomy.term('people.titlePlural')}`} />
      <Box p="200">
        <Panel>
          <PanelHeader>
            <PanelTitle level="1">Add {taxonomy.term('people.titlePlural')}</PanelTitle>
            <PanelDescription>
              Real-time {taxonomy.term('people.plural')} and event data is the foundation of timely and relevant
              messages.
            </PanelDescription>
          </PanelHeader>

          <PanelSection>
            <AddPeopleActions isBuilder={isBuilder} onActionClick={handleActionClick} />
          </PanelSection>
        </Panel>
      </Box>
    </>
  );
}
